module.exports = __webpack_public_path__ + "img/mirror06.0ed2282a.jpg";